import './scripts/common';

import Tooltip from 'bootstrap/js/dist/tooltip';
import {onFind} from "@elements/init-modules-in-scope";
onFind('[data-bs-toggle="tooltip"]',function (element) {
    new Tooltip(element);
});

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as azTeaserSlider from './scripts/az-teaser-slider';
azTeaserSlider.init();

import * as imgTeaserSlider from './scripts/img-teaser-slider';
imgTeaserSlider.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({addUrlParams: true});

import * as multiselectDropdown from './scripts/multiselect-dropdown';
multiselectDropdown.init();

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as scrollTop from './scripts/scroll-top';
scrollTop.init();

import * as googleMap from "./scripts/google-map";
googleMap.init();

import 'bootstrap/js/dist/dropdown';
import Collapse from 'bootstrap/js/dist/collapse';

import * as conditionalForm from "./scripts/conditional-form";
conditionalForm.init();

import * as wishlist from './scripts/wishlist';
wishlist.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init();

import * as typeahead from './scripts/typeahead';
typeahead.init();

import * as fileInput from '@elements/file-input';
fileInput.init();

import * as fileInputReset from './scripts/file-input-reset';
fileInputReset.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();